/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=5c397a1e"
const script = {}

import exportComponent from "E:\\code\\zd\\h5\\app_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__